// BrandConnect main router
// /brandconnect/campaign              → campaign list (with sidebar)
// /brandconnect/campaign/:id/dashboard → dashboard   (NO sidebar)

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import BrandConnectLayout from './BrandConnectLayout';
import HybridCampaigns from './HybridCampaigns';
import HybridCampaignDashboard from './HybridCampaignDashboard';
import HybridDiscover from './HybridDiscover';
import HybridDeals from './HybridDeals';

export default function BrandConnect() {
    return (
        <>
            <Toaster position="top-right" />
            <Switch>
                {/* Discover page */}
                <Route exact path="/brandconnect/discover">
                    <BrandConnectLayout>
                        <HybridDiscover />
                    </BrandConnectLayout>
                </Route>

                {/* Collab List */}
                <Route exact path="/brandconnect/collab">
                    <BrandConnectLayout>
                        <HybridDeals />
                    </BrandConnectLayout>
                </Route>

                {/* Dashboard — no sidebar */}
                <Route exact path="/brandconnect/campaign/:campaignId/dashboard">
                    <BrandConnectLayout showSidebar={false}>
                        <HybridCampaignDashboard />
                    </BrandConnectLayout>
                </Route>

                {/* Campaign list — with sidebar */}
                <Route exact path="/brandconnect/campaign">
                    <BrandConnectLayout>
                        <HybridCampaigns />
                    </BrandConnectLayout>
                </Route>
            </Switch>
        </>
    );
}
